import { css } from "@compiled/react";

import StoryObject from "@atlaskit/object/story";

type Story16IconCustomProps = {
    readonly primaryColor: string;
    readonly label: string;
};

export const Story16IconCustom = ({
    primaryColor,
    label
}: Story16IconCustomProps) => {
    const colorOverride = css({
        color: primaryColor
    });

    return (
        <div css={colorOverride}>
            <StoryObject label={label} />
        </div>
    );
};
